export default __webpack_public_path__ + "static/media/copy.84877f27.svg";